import PopularSliderSection from "@/templates/home/_components/Search/PopularSliderSection";
import { GLOBAL_SEARCH_RESULTS_SECTIONS } from "@/utils/constant";
import { useAppSelector } from "@/utils/hooks/reactUseCustomHooks";
import { Box, Tag, Text } from "@dxp-feed/ui";
import Link from "@/components/Link";

const NoRecipeMatched = ({
  slug,
  recipeContent,
}: {
  slug: string;
  recipeContent: any;
}) => {
  const { aemFilterData }: any = useAppSelector(
    (state) => state.getAemDataSlice
  );
  return (
    <>
      <Box
        as="div"
        className="text-center flex items-center  justify-center flex-col gap-4 lg:gap-6"
      >
        <Text as="h1" className="title-secondary font-bold">
          {/* No recipes match your selected filters. */}
          {aemFilterData?.noRecipeFoundText
            ? aemFilterData?.noRecipeFoundText?.split(".")[0] + "."
            : "No recipes match your selected filters."}
        </Text>
        <Box className="flex gap-2">
          <Tag
            variant="secondary"
            className="!rounded-[4px] px-2 !py-1 !bg-[rgba(122,122,122,0.12)] backdrop-blur-[5px] flex gap-1"
          >
            {slug}
            <Link href="/recipes">
              <Text
                as="span"
                className="icon-close text-brandBlack text-[14px] font-bold cursor-pointer w-6 h-6 flex items-center justify-center"
              ></Text>
            </Link>
          </Tag>
        </Box>
        <Text as="p" className="text-[14px]">
          {/* Try adjusting your options to discover new possibilities! */}
          {aemFilterData?.noRecipeFoundText
            ? aemFilterData?.noRecipeFoundText.split(".")[1]
            : "Try adjusting your options to discover new possibilities!"}
        </Text>
      </Box>

      <Box className="w-full mb-[48px] md:mb-0 pb-[24px] 2md:pb-[48px]  ">
        <PopularSliderSection
          type={GLOBAL_SEARCH_RESULTS_SECTIONS.RECIPE}
          title={recipeContent?.recipesCarouselTitle}
          titleCTA={recipeContent?.recipesCarouselCTA}
          slideCount={12}
          showControls={true}
        />
      </Box>
    </>
  );
};
export default NoRecipeMatched;